import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as SoundManager from '../../../utils/SoundManager';
import * as api from '../../../api';
import './VideoPlayer.css';
import { VIDEO_RATIO, ASSETS_FOLDER, IFRAME_ORIGIN } from '../../../constants';
import { trackEvent } from '../../../utils/Stats';
import { videoComplete, soundBlocked } from '../../../redux/actions';
import * as Features from '../../../utils/Features';
import * as utils from '../../../utils';

class VideoPlayer extends Component {
  constructor(props) {
    super(props);

    // ref
    this.frameRef = React.createRef();
    this.fillRef = React.createRef();

    // bind
    this.handleLoad = this.handleLoad.bind(this);
  }

  // ----------------------------------------------------
  // Lifecycle
  // ----------------------------------------------------

  componentDidMount() {
    SoundManager.muteAtmo(true);
    trackEvent('video', this.props.source);
    if (!this.props.compact) {
      utils.scrollToTop();
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.source !== this.props.source) {
      this.clearLoops();
      trackEvent('video', nextProps.source);
    }
    return true;
  }

  componentWillUnmount() {
    this.clearLoops();
    if (!this.props.compact) {
      this.props.soundBlocked(SoundManager.muteAtmo(false));
      utils.scrollToTop();
    }
  }

  // ----------------------------------------------------
  // Player
  // ----------------------------------------------------

  getVideoSource() {
    const { source } = this.props;
    return `${IFRAME_ORIGIN}/?hash=${api.getHash()}&bonus=${source}&allControlsHidden=${
      //Features.features.mobile || Features.features.safari ? 0 : 1
      0 // povolit vzdy
    }&origin=noads&autoStart=true`;
  }

  clearLoops() {
    clearInterval(this.checkLoop);
    clearInterval(this.progressLoop);
  }

  updateCall(a) {
    if (a === 'ended') {
      this.props.videoComplete(this.props.source);
      this.props.onEnded();
      trackEvent('video', 'end');
    }
  }

  checkDuration(content) {
    if (this.duration <= 0) {
      // note - tricky - but the only way for now
      const durationArray = content.document
        .getElementById('totalTimeInfo')
        .innerText.split(':');
      this.duration = Number(durationArray[0]) * 60 + Number(durationArray[1]);
    }
  }

  progressLineUpdate(value) {
    this.fillRef.current.style.width = `${Math.round(
      100 * Math.max(0, Math.min(value, 1))
    )}%`;
  }

  progressUpdate(content) {
    if (content.player) {
      const position = content.player.getStreamPosition();
      this.checkDuration(content);
      // update progress
      this.progressLineUpdate(position / this.duration);
    }
  }

  frameInited(content) {
    // reset progress
    this.duration = 0;
    this.progressLineUpdate(0);
    // set progress interval
    clearInterval(this.progressLoop); // for sure - to prevent multiple init
    this.progressLoop = setInterval(() => {
      this.progressUpdate(content);
    }, 250);
  }

  initCheck() {
    const content = this.frameRef.current.contentWindow;
    if (content !== undefined) {
      clearInterval(this.checkLoop);
      try {
        content.callbackStatus = (a, b, c) => {
          this.updateCall(a, b, c);
        };
        this.frameInited(content);
      } catch (err) {
        // note - probably save to log
      }
    }
  }

  handleLoad() {
    clearInterval(this.checkLoop); // for sure - to prevent multiple init
    this.checkLoop = setInterval(() => {
      this.initCheck();
    }, 200);
  }

  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------

  render() {
    // video centering
    const { width, height, disablePointer } = this.props;
    const videoScale = Math.min(width / VIDEO_RATIO.W, height / VIDEO_RATIO.H);
    const videoW = Math.round(VIDEO_RATIO.W * videoScale);
    const videoH = Math.round(VIDEO_RATIO.H * videoScale);
    const styleFrame = {
      left: `${(width - videoW) * 0.5}px`,
      top: `${(height - videoH) * 0.5}px`,
      width: `${videoW}px`,
      height: `${videoH}px`,
    };
    const styleGradientH = {
      display: videoW === width ? 'none' : 'block',
    };
    const styleGradientW = {
      display: videoH === height ? 'none' : 'block',
    };

    return (
      <div
        className={`video-player-wrap ${
          false && // povolit ovladani
          disablePointer &&
          !Features.features.safari &&
          !Features.features.mobile
            ? 'disable-pointer'
            : ''
        }`}
      >
        <div className="video-frame-wrap" style={styleFrame}>
          <iframe
            ref={this.frameRef}
            className="video-frame"
            title="Dukla 61 - video"
            width={videoW}
            height={videoH}
            src={this.getVideoSource()}
            onLoad={this.handleLoad}
            allowFullScreen
          />
          <img
            className="gradient-top"
            src={`${ASSETS_FOLDER}img/video-gradient/top.png`}
            alt="Gradient"
            style={styleGradientW}
          />
          <img
            className="gradient-bottom"
            src={`${ASSETS_FOLDER}img/video-gradient/bottom.png`}
            alt="Gradient"
            style={styleGradientW}
          />
          <img
            className="gradient-left"
            src={`${ASSETS_FOLDER}img/video-gradient/left.png`}
            alt="Gradient"
            style={styleGradientH}
          />
          <img
            className="gradient-right"
            src={`${ASSETS_FOLDER}img/video-gradient/right.png`}
            alt="Gradient"
            style={styleGradientH}
          />
        </div>
        {!Features.features.mobile &&
          !Features.features.safari && (
            <div className="progressbar">
              <div className="fill" ref={this.fillRef} />
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  width: state.ui.width,
  height: state.ui.height,
  compact: state.ui.compact,
});

const mapDispatchToProps = dispatch => ({
  videoComplete: videoId => dispatch(videoComplete(videoId)),
  soundBlocked: soundBlockState => dispatch(soundBlocked(soundBlockState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/components/Shared/VideoPlayer/VideoPlayer.js